import { ADJUSTER_REPORT_BASE_PATH } from '@/config/baseModulesLink';

export const ADJUSTER_REPORT_CULPRIT_PATHS = {
  INFORMATION: {
    base: 'culprit-information',
    INSURANCE: { show: 'insurance-show ', edit: 'insurance' },
    VEHICLE_INFORMATION: {
      EDIT: { base: 'vehicle-information', partTwo: 'part-two' },
      show: ' vehicle-information',
    },
    DRIVER_OWNER: {
      EDIT: {
        base: 'driver-information',
        certificate: 'certificate',
        driverContact: 'driver-contract',
        owner: 'owner',
        ownerContact: 'owner-contract',
      },
      show: 'show',
    },
  },
  IMAGES: {
    base: 'culprit-images',
    ADJUSTER: {
      base: 'adjuster',
      VEHICLE: {
        base: 'vehicle',
        damagedPoints: 'damaged-points',
        takePhotoGuide: 'take-photo-guide',
        takePhotoFlow: 'take-photo-flow',
        PreviewImages: 'preview-images',
        editablePreviewImages: 'editable-preview-images',
        showPreviewImages: 'show-preview-images',
        previewImageDamagePoint: 'preview-image-damage-point',
      },
      DOCUMENT: { edit: 'document', show: 'show-document' },
      ADDITIONAL: { edit: 'additional', show: 'show-additional' },
      CROQUIS: { edit: 'croquis', show: 'show-croquis' },
    },
    CUSTOMER: {
      base: 'customer',
      vehicleImages: 'preview-images',
      document: 'document',
      additional: 'additional',
    },

    SIGNATURE: { edit: 'signature', show: 'show-signature' },
    corrective: 'corrective',
  },
} as const;
export const ADJUSTER_REPORT_CULPRIT_LINKS = {
  CULPRIT_INFORMATION: ({ id }: { id: number }) => {
    const CULPRIT_INFORMATION = ADJUSTER_REPORT_CULPRIT_PATHS.INFORMATION;

    const culpritInformationBase = `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${CULPRIT_INFORMATION.base}`;
    return {
      culpritInformationTabsPage: culpritInformationBase,
      INSURANCE: {
        edit: `${culpritInformationBase}/${CULPRIT_INFORMATION.INSURANCE.edit}`,
        show: `${culpritInformationBase}/${CULPRIT_INFORMATION.INSURANCE}/${CULPRIT_INFORMATION.INSURANCE.show}`,
      },
      VEHICLE_INFORMATION: {
        partOne: `${culpritInformationBase}/${CULPRIT_INFORMATION.VEHICLE_INFORMATION.EDIT.base}`,
        partTwo: `${culpritInformationBase}/${CULPRIT_INFORMATION.VEHICLE_INFORMATION.EDIT.base}/${CULPRIT_INFORMATION.VEHICLE_INFORMATION.EDIT.partTwo}`,
        show: `${culpritInformationBase}/${CULPRIT_INFORMATION.VEHICLE_INFORMATION.show}`,
      },
      DRIVER_OWNER_INFORMATION: {
        driver: `${culpritInformationBase}/${CULPRIT_INFORMATION.DRIVER_OWNER.EDIT.base}`,
        certificate: `${culpritInformationBase}/${CULPRIT_INFORMATION.DRIVER_OWNER.EDIT.base}/${CULPRIT_INFORMATION.DRIVER_OWNER.EDIT.certificate}`,
        driverContact: `${culpritInformationBase}/${CULPRIT_INFORMATION.DRIVER_OWNER.EDIT.base}/${CULPRIT_INFORMATION.DRIVER_OWNER.EDIT.driverContact}`,
        owner: `${culpritInformationBase}/${CULPRIT_INFORMATION.DRIVER_OWNER.EDIT.owner}`,
        ownerContact: `${culpritInformationBase}/${CULPRIT_INFORMATION.DRIVER_OWNER.EDIT.owner}/${CULPRIT_INFORMATION.DRIVER_OWNER.EDIT.ownerContact}`,
        show: `${culpritInformationBase}/${CULPRIT_INFORMATION.DRIVER_OWNER.show}`,
      },
    };
  },
  CULPRIT_IMAGES: ({ id }: { id: number }) => {
    const CULPRIT_IMAGES_BASE = `/${ADJUSTER_REPORT_BASE_PATH}/${id}/${ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.base}`;
    const ADJUSTER_IMAGES_BASE = `${CULPRIT_IMAGES_BASE}/${ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.base}`;
    const ADJUSTER_VEHICLE_BASE = `${ADJUSTER_IMAGES_BASE}/${ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.VEHICLE.base}`;
    const CUSTOMER_IMAGES_BASE = `${CULPRIT_IMAGES_BASE}/${ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.CUSTOMER.base}`;

    return {
      imagesTabPage: CULPRIT_IMAGES_BASE,
      ADJUSTER_VEHICLE: {
        damagedPoints: `${ADJUSTER_VEHICLE_BASE}/${ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.VEHICLE.damagedPoints}`,
        takePhotoGuide: `${ADJUSTER_VEHICLE_BASE}/${ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.VEHICLE.takePhotoGuide}`,
        takePhotoFlow: `${ADJUSTER_VEHICLE_BASE}/${ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.VEHICLE.takePhotoFlow}`,
        PreviewImages: `${ADJUSTER_VEHICLE_BASE}/${ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.VEHICLE.PreviewImages}`,
        editablePreviewImages: `${ADJUSTER_VEHICLE_BASE}/${ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.VEHICLE.editablePreviewImages}`,
        showPreviewImages: `${ADJUSTER_VEHICLE_BASE}/${ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.VEHICLE.showPreviewImages}`,
        previewImageDamagePoint: `${ADJUSTER_VEHICLE_BASE}/${ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.VEHICLE.previewImageDamagePoint}`,
      },
      ADJUSTER_DOCUMENT: {
        edit: `${ADJUSTER_IMAGES_BASE}/${ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.DOCUMENT.edit}`,
        show: `${ADJUSTER_IMAGES_BASE}/${ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.DOCUMENT.show}`,
      },
      ADJUSTER_ADDITIONAL: {
        edit: `${ADJUSTER_IMAGES_BASE}/${ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.ADDITIONAL.edit}`,
        show: `${ADJUSTER_IMAGES_BASE}/${ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.ADDITIONAL.show}`,
      },
      ADJUSTER_CROQUIS: {
        edit: `${ADJUSTER_IMAGES_BASE}/${ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.CROQUIS.edit}`,
        show: `${ADJUSTER_IMAGES_BASE}/${ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.ADJUSTER.CROQUIS.show}`,
      },
      customerVehicle: `${CUSTOMER_IMAGES_BASE}/${ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.CUSTOMER.vehicleImages}`,

      customerDocument: `${CUSTOMER_IMAGES_BASE}/${ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.CUSTOMER.document}`,

      customerAdditional: `${CUSTOMER_IMAGES_BASE}/${ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.CUSTOMER.additional}`,

      SIGNATURE: {
        edit: `${CULPRIT_IMAGES_BASE}/${ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.SIGNATURE.edit}`,
        show: `${CULPRIT_IMAGES_BASE}/${ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.SIGNATURE.show}`,
      },
      corrective: `${CULPRIT_IMAGES_BASE}/${ADJUSTER_REPORT_CULPRIT_PATHS.IMAGES.corrective}`,
    };
  },
};
